import { takeEvery, all, call, put } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'
import { clearTrackSummery, DOWnLOAD_TRACK_SUMMARY, putTrackSummery, TOGGLE_SELECTED_VIDEO_ALL, TOGGLE_SELECTED_VIDEOLIST_ALL } from '../../store/ContentAllVideolists/actions'
import { loading } from '../../store/App/actions'

export default function* () {
    yield takeEvery(DOWnLOAD_TRACK_SUMMARY, worker)
    yield takeEvery(TOGGLE_SELECTED_VIDEO_ALL, worker)
    // yield takeEvery(TOGGLE_SELECTED_VIDEOLIST_ALL, worker)
}

function* worker({ action, payload }) {

    if (action === TOGGLE_SELECTED_VIDEOLIST_ALL || !payload.id_video.length) {
        yield put(clearTrackSummery())        
    }else

    // yield put(loading(true))

    try {

        const summery = yield call(fetchSummery, payload.id_video)
        if (summery.error) {
            yield put(showAlertError({
                errors: [`Ошибка сети при ${DOWnLOAD_TRACK_SUMMARY}.`, summery],
                text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу." + summery.error
            }))
            yield put(loading(false))
            return
        }
        if (Array.isArray(summery) && summery.length) {
            yield put(putTrackSummery(findIntersections(summery)))
        }

    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${DOWnLOAD_TRACK_SUMMARY}.`, e],
            text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу." + e
        }))
    }
    // finally {
    //     yield put(loading(false))
    // }

}

function fetchSummery(ids) {
    return axios.get(`/videolist/tracks/summary?${ids.map(id => `id[]=${id}`).join('&')}`)
        .then(response => response.data)
}

function findIntersections(items) {
    if (items.length < 2) return items[0].videolists;

    // Берём videolists первого элемента как базу
    const base = new Set(items[0].videolists);

    // Пересекаем с остальными
    const intersection = items.slice(1).reduce((acc, item) => {
        const current = new Set(item.videolists);
        return new Set([...acc].filter(id => current.has(id)));
    }, base);

    return [...intersection];
}